module.exports = __webpack_public_path__ + "985e8f75ea7853f5286db0dbcdcca2e6.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/reports/truck-illustration.svg
// module id = 976
// module chunks = 0